<template>
	<v-card class="mx-auto" max-width="600">
		<v-toolbar color="purple" dark>
			<v-app-bar-nav-icon></v-app-bar-nav-icon>

			<v-toolbar-title>Check List helper</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-btn icon>
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
		</v-toolbar>

		<v-list flat subheader>
			<v-subheader>Travel</v-subheader>

			<v-list-item-group
				v-model="settings"
				multiple
				active-class="pink--text"
			>
				<v-list-item v-for="list_item in list.travel">
					<template v-slot:default="{ active }">
						<v-list-item-action>
							<v-checkbox v-model="active"></v-checkbox>
						</v-list-item-action>

						<v-list-item-content>
							<v-list-item-title>{{
								list_item
							}}</v-list-item-title>
						</v-list-item-content>
					</template>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<v-divider></v-divider>

		<v-card-actions>
			<v-btn block text @click="settings = []">RESET</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	mounted() {
		try {
			this.settings = JSON.parse(localStorage.settings);
		} catch (e) {}
	},
	watch: {
		settings(newSetting) {
			let parsed = JSON.stringify(newSetting);

			localStorage.settings = parsed;
		}
	},
	data() {
		return {
			settings: [],
			list: {
				travel: [
					"護照及當地簽證",
					"當地現金",
					"提款卡",
					"信用卡",
					"旅行相關文件 (酒店預約資料, 機票, 巴士資料)",
					"轉插",
					"衫, 褲, 內衣, 襪",
					"清潔用品 (沐浴露, 洗頭水)",
					"禦寒外套, 手套, 帽",
					"藥物",
					"手機, 充電器",
					"紙巾",
					"牙刷, 牙膏",
					"生理用品",
					"隠型眼鏡",
					"零錢包",
					"保鮮盒, 水壺",
					"筆記, 筆"
				]
			}
		};
	}
};
</script>
